import React from "react";
import {useQuery} from "react-query";
import {apiV2} from "@/api/axiosConfig";
import {nilObjectID} from "@/lib/misc/nilObjectID";

type IncidentFeed = {
    id: string;
    name: string;
    clientID: string;
    clientName: string;
    type: string;
    reference: string;
}

type FeedNameProps = {
    feedID: string;
}

const fetchFeed = async (feedID: string): Promise<IncidentFeed> => {

    const response = await apiV2.get<IncidentFeed>(`incident-feeds/${feedID}`);
    return response.data;
};

export const FeedName: React.FC<FeedNameProps> = ({feedID}) => {
    const {data: feed, isLoading, isError} = useQuery(
        ["incident-feed", feedID],
        () => fetchFeed(feedID),
        {
            enabled: !!(feedID && feedID != nilObjectID),
            staleTime: 10 * 60 * 1000, // 10 minutes
            cacheTime: 30 * 60 * 1000, // 30 minutes
        }
    );

    if (!feedID || feedID == nilObjectID) {
        return <span className="text-grey">N/A</span>;
    }


    if (isLoading) {
        return <span className="text-grey">Loading...</span>;
    }

    if (isError || !feed) {
        return <span className="text-grey">Unknown</span>;
    }

    return <span>{feed.name}</span>;
};
